import { render, staticRenderFns } from "./to-be-certified.vue?vue&type=template&id=b1199f7e&scoped=true"
import script from "./to-be-certified.vue?vue&type=script&lang=js"
export * from "./to-be-certified.vue?vue&type=script&lang=js"
import style0 from "./to-be-certified.vue?vue&type=style&index=0&id=b1199f7e&prod&lang=scss&scoped=scoped"
import style1 from "./to-be-certified.vue?vue&type=style&index=1&id=b1199f7e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1199f7e",
  null
  
)

export default component.exports